import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Crown, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { usePremium } from '../hooks/usePremium';
import Confetti from 'react-confetti';
import { trackPurchase } from '../utils/analytics';

export const PremiumSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const { refetch } = usePremium();

  useEffect(() => {
    // Refetch premium status after successful checkout
    if (sessionId) {
      refetch();
    }
  }, [sessionId, refetch]);

  useEffect(() => {
    // Checkout success return. Deduplicated inside; no-op unless GA4 is on.
    trackPurchase(sessionId);
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-primary/5 to-primary/10">
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        recycle={false}
        numberOfPieces={500}
      />

      <div className="max-w-md w-full bg-background rounded-xl shadow-xl p-8 text-center space-y-6">
        <div className="flex justify-center">
          <div className="relative">
            <Crown className="h-20 w-20 text-primary" />
            <CheckCircle className="h-8 w-8 text-emerald-500 absolute -bottom-1 -right-1 bg-background rounded-full" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">Welcome to Premium!</h1>
          <p className="text-muted-foreground">
            Your premium subscription is now active. Enjoy exclusive features, advanced analytics, and ad-free gameplay.
          </p>
        </div>

        <div className="space-y-3 pt-4">
          <Button
            onClick={() => navigate('/popular')}
            variant="primary"
            className="w-full"
          >
            Start Playing
          </Button>
          <Button
            onClick={() => navigate('/settings')}
            variant="outline"
            className="w-full"
          >
            View Settings
          </Button>
        </div>

        <p className="text-xs text-muted-foreground">
          You can manage your subscription anytime from your account settings.
        </p>
      </div>
    </div>
  );
};
